import React, { useState } from "react";
import { Button } from 'primereact/button';

export function SubmitButton({ disabled, searchInProgress, handleSubmitClick }) {
    return (
        <div className="flex mt-3">
            <Button label="Submit" icon="pi pi-check" loading={searchInProgress} onClick={handleSubmitClick} disabled={disabled} />
        </div>);
}